export default "__VITE_ASSET___oQIl3rO__"